import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { AnNamElement } from "../../base-element";

type UnitPriceMap = Record<string, string>;

@customElement("an-unit-price")
export class AnUnitPrice extends AnNamElement {
  @property({ attribute: "variant-prices", type: String })
  declare variantPrices: string;

  @property({ attribute: "current-variant-id", type: String })
  declare currentVariantId: string;

  constructor() {
    super();
    this.variantPrices = "{}";
    this.currentVariantId = "";
  }

  @state()
  private pricingByVariant: UnitPriceMap = {};

  connectedCallback(): void {
    super.connectedCallback();
    this.pricingByVariant = this.parsePricing(this.variantPrices);
    this.listenToVariantInput();
  }

  render() {
    const label = this.pricingByVariant[this.currentVariantId];
    if (!label) return html``;

    return html`<small class="unit-price caption"><span class="price-item price-item--last">${label}</span></small>`;
  }

  private parsePricing(serialized: string): UnitPriceMap {
    try {
      return JSON.parse(serialized) as UnitPriceMap;
    } catch {
      return {};
    }
  }

  private listenToVariantInput(): void {
    const form = this.closest("section")?.querySelector('form[action*="/cart/add"]');
    const variantInput = form?.querySelector('input[name="id"]') as HTMLInputElement | null;
    if (!variantInput) return;

    this.currentVariantId = variantInput.value;
    variantInput.addEventListener("change", () => {
      this.currentVariantId = variantInput.value;
    });
  }
}
